module.exports = __webpack_public_path__ + "static/media/logo_kleinanzeigen.a2adf021.svg";